import { Box, Typography } from "@mui/material";

import { ExpandMoreIcon } from "../../../../../2_ksbHub/icons/icons";

export default function BszClassHeader({
  className,
  studentCount,
  isOpen,
  onClick,
}) {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
        px: 0.5,
        py: 0.5,
        borderRadius: 1,
        "&:hover": {
          backgroundColor: "rgba(255,255,255,0.05)",
        },
      }}
    >
      <Typography sx={{ fontWeight: 700 }}>
        {className} ({studentCount})
      </Typography>

      <ExpandMoreIcon
        sx={{
          transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          transition: "transform 0.2s",
        }}
      />
    </Box>
  );
}
